<template>
  <div class="main-content">
    <avue-crud
      ref="crud"
      :data="tableData"
      :option="option"
      :table-loading="showLoading"
      :page.sync="page"
      @on-load="onLoad"
    >
      <template #header>
        <div>
          <div class="flex flex-wrap align-items marginBottom20">
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight">管理员 : </span>
              <div class="width300">
                <el-input
                  v-model="searchData.fullName"
                  placeholder="请输入"
                  clearable
                  maxlength="30"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight">邮箱号 : </span>
              <div class="width300">
                <el-input
                  v-model="searchData.email"
                  placeholder="请输入"
                  clearable
                  maxlength="30"
                ></el-input>
              </div>
            </div>

            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight">绑定时间 : </span>
              <div class="width300">
                <el-date-picker
                  v-model="searchData.createTime"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :clearable="true"
                >
                  <!-- @change="handleSearch" -->
                </el-date-picker>
              </div>
            </div>
            <el-button
              size="medium"
              type="primary"
               
              @click="handleSearch"
              style="margin-bottom: 10px"
              class="marginLeft10"
              >搜索</el-button
            >
            <el-button
              size="medium"
              type="info"
                
              @click="handleReset"
              class="marginLeft10"
              style="margin-bottom: 10px"
              >重置</el-button
            >
          </div>
        </div>
      </template>
    </avue-crud>
  </div>
</template>

<script>
import { operateLogList } from "@/api/operate/log";
import dayjs from "dayjs";

export default {
  name: "index",
  data() {
    return {
      searchData: {
        title: "",
        createTime: "",
      },
      page: {
        total: 0,
        currentPage: 1,
      },
      tableData: [],
      showLoading: false,
      showLoadingForm: false,
      dialogVisible: false,
      option: {
        rowKey:'index',
        title: "",
        titleSize: "h3",
        card: false,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: false, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        page: true, // 显示分页
        align: "center",
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        menu: false,
        column: [
          {
            label: "登录时间",
            prop: "loginTime",
          },
          {
            label: "操作时间",
            prop: "createTime",
          },
          {
            label: "管理员名称",
            prop: "fullName",
          },
          {
            label: "角色权限",
            prop: "roleName",
          },
          {
            label: "邮箱",
            prop: "email",
          },
          {
            label: "操作模块",
            prop: "operateMenu",
          },
          {
            label: "操作名称",
            prop: "operateName",
          },
          {
            label: "IP",
            prop: "ip",
          },
        ],
      },

      dialogVisible: false,
      // form: {
      //   id: "",
      //   // sort: " ",
      //   title: "",
      //   details: "",
      // },
    };
  },
  created() {},
  methods: {
    onLoad() {
      this.showLoading = true;
      const searchData = {
        ...this.searchData,
      };
      if (this.searchData.createTime) {
        searchData.createTimeStart = dayjs(
          this.searchData.createTime[0]
        ).format("YYYY-MM-DD 00:00:00");
        searchData.createTimeEnd = dayjs(this.searchData.createTime[1]).format(
          "YYYY-MM-DD 23:59:59"
        );
      }
      delete searchData.createTime;
      // console.log(searchData,'this.searchDatathis.searchData');
      operateLogList({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...searchData,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        }
      });
    },

    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 重置
    handleReset() {
      // console.log('重置')
      this.searchData = {
        state: "",
        name: "",
        createTime: "",
      };
      this.page.currentPage = 1;
      this.onLoad();
    },

    //输入
    salaryDianChange(e, t) {
      const value = e.target.value;
      this.form[t] = value;
    },
  },
};
</script>

<style scoped>
</style>